// extracted by mini-css-extract-plugin
module.exports = {"wrap":"PageHeader_wrap__1myVX"};